/* eslint-disable react-hooks/exhaustive-deps, no-unused-vars, eqeqeq, no-lone-blocks */
import React, { useEffect, useState } from 'react';
import Modal from './Modal';
import DateTimePickerModal from './DateTimePickerModal';
import { toLocalISO } from '../utils/dateHelper';
import { ImageBaseUrl } from '../api/api';
import { DefaultemailIcon, DefaultUserIcon } from './Icon';
import { useTranslation } from '../hooks/useTranslation';
import { useLangMap } from '../hooks/useLangMap';
import CustomAlert from './CustomAlert';

const ContentChangePopup = ({
  isOpen,
  onBack,
  onStartApproval,
  revisionresponse,
  versionPopupPayload,
  type,
  supportedLanguages = [],
  selectedLanguage,
}) => {
  const [selectedDate, setSelectedDate] = useState('');
  const [tempDate, setTempDate] = useState('');
  const [showCalendar, setShowCalendar] = useState(false);
  const [emailLanguage, setEmailLanguage] = useState('');

  const [ccRoles, setCcRoles] = useState({
    architect: false,
    manager: false,
    modeler: false,
  });

  const [personalMessage, setPersonalMessage] = useState('');

  const t = useTranslation();
  const langMap = useLangMap();

  // ==========================
  // DEFAULT DATE = NEXT MONTH 1st, 08:00
  // ==========================
  useEffect(() => {
    const now = new Date();
    const defaultDate = new Date(now.getFullYear(), now.getMonth() + 1, 1, 8, 0);

    const iso = toLocalISO(defaultDate);
    setSelectedDate(iso);
    setTempDate(iso);
  }, []);

  if (!isOpen) return null;

  // Format date for UI
  const formattedDisplay = (() => {
    if (!selectedDate) return '';
    const d = new Date(selectedDate);
    const month = d.toLocaleString('default', { month: 'long' });
    const day = d.getDate();
    const time = d.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
    });
    return `${month} ${day} : ${time}`;
  })();

  const rawContactInfo = versionPopupPayload?.contact_info || revisionresponse?.contact_info;

  const contactInfo = (() => {
    if (!rawContactInfo) return {};
    if (typeof rawContactInfo === 'string') {
      try {
        return JSON.parse(rawContactInfo);
      } catch (e) {
        return {};
      }
    }
    return rawContactInfo;
  })();

  const extractFirstId = (val) => {
    if (val === null || val === undefined) return null;
    if (Array.isArray(val)) {
      const found = val.find((item) => item !== null && item !== undefined && item !== '');
      return found ?? null;
    }
    return val !== '' ? val : null;
  };

  const processOwnerId =
    extractFirstId(contactInfo?.domain_owner) || extractFirstId(contactInfo?.owner) || null;

  const findUserById = (userId, assignedUsers) => {
    if (!userId || !assignedUsers || !Array.isArray(assignedUsers)) return null;

    const match = assignedUsers.find((item) => {
      const uId = item?.user?.id ?? item?.id ?? item?.user_id;
      return String(uId) === String(userId);
    });

    if (!match) return null;

    const u = match.user || match;
    return {
      id: u.id,
      first_name: u.first_name || '',
      last_name: u.last_name || '',
      email: u.email || '',
      image: u.image || u.profile_image || null,
    };
  };

  const processOwner = findUserById(processOwnerId, revisionresponse?.assigned_users);

  return (
    <Modal modalStyle={{ width: '550px' }}>
      <h2 className="content_change_popup  fs-12 fw-500 global-color mt-0 mb-10">
        {t('publish_process')}
      </h2>
      <h3 className="fs-12 fw-500 global-color mt-0 mb-5 bb-1 pb-5">
        {' '}
        {t('request_process_approval')}
      </h3>
      <p className="mt-0 fs-12">{t('please_review_details_and_add_personal_message')}.</p>

      {/* =======================
          PROCESS OWNER DISPLAY
      ========================== */}
      <div style={{ marginTop: '10px' }}>
        <label className="content_change_popup  fs-12 fw-500 global-color mt-0 mb-5 d-block">
          {t('process_owner_process_domain_owner')}
        </label>

        <div className="owner_details_list b-1 p-10">
          <div className="owner_details">
            <div className="owner-pic">
              {processOwner?.image ? (
                <>
                  <img
                    src={
                      typeof processOwner.image === 'string' &&
                      processOwner.image.startsWith('http')
                        ? processOwner.image // ✅ Google ka full URL
                        : `${ImageBaseUrl}uploads/profile_images/${processOwner.image}` // ✅ Local image
                    }
                    alt="Profile"
                    onError={(e) => {
                      e.target.style.display = 'none';
                      const fallback = e.target.nextSibling;
                      if (fallback) fallback.style.display = 'inline-block';
                    }}
                  />
                  <span style={{ display: 'none' }}>
                    <DefaultUserIcon />
                  </span>
                </>
              ) : (
                <DefaultUserIcon />
              )}
            </div>
            <div className="owner-desc">
              <span className="owner-name">
                {processOwner
                  ? `${processOwner.first_name || ''} ${processOwner.last_name || ''}`.trim() || '—'
                  : '—'}
              </span>

              {processOwner?.email ? (
                <div className="owner-email">
                  <a
                    href={`mailto:${processOwner.email}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <DefaultemailIcon />
                  </a>
                </div>
              ) : null}
            </div>
          </div>
        </div>
      </div>

      {type === 'Swimlane' && (
        <>
          <h3 className="content_change_popup  fs-12 fw-500 global-color mb-5 d-block">
            {' '}
            {t('inform_cc_the_following_roles')}:
          </h3>
          <div className="b-1 p-10 lable_list">
            {/* Process Architect(s) */}
            {contactInfo?.architecture?.length > 0 && (
              <label className="fs-12">
                <input
                  type="checkbox"
                  checked={ccRoles.architect}
                  onChange={() => setCcRoles({ ...ccRoles, architect: !ccRoles.architect })}
                />
                {t('process_architects')}
              </label>
            )}

            {/* Process Manager(s) */}
            {contactInfo?.manager?.length > 0 && (
              <label className="fs-12">
                <input
                  type="checkbox"
                  checked={ccRoles.manager}
                  onChange={() => setCcRoles({ ...ccRoles, manager: !ccRoles.manager })}
                />
                {t('process_managers')}
              </label>
            )}

            {/* Process Modeler(s) */}
            {contactInfo?.modeler?.length > 0 && (
              <label className="fs-12">
                <input
                  type="checkbox"
                  checked={ccRoles.modeler}
                  onChange={() => setCcRoles({ ...ccRoles, modeler: !ccRoles.modeler })}
                />
                {t('process_modelers')}
              </label>
            )}
          </div>
        </>
      )}

      {/* =======================
          PLANNED PUBLISHING DATE
      ========================== */}
      <h3 className="content_change_popup  fs-12 fw-500 global-color mb-5 d-block">
        {' '}
        {t('planned_publishing_date')}:
      </h3>

      <div className="b-1 p-10">
        <label className="fs-12">{formattedDisplay}</label>
        <button
          className="btn-small ml-10"
          onClick={(e) => {
            e.preventDefault();
            setTempDate(selectedDate);
            setShowCalendar(true);
          }}
        >
          {t('edit')}
        </button>
      </div>

      <DateTimePickerModal
        isOpen={showCalendar}
        onClose={() => setShowCalendar(false)}
        minDate={new Date()}
        onSave={(value) => {
          const iso = toLocalISO(value);
          setSelectedDate(iso);
          setTempDate(iso);
          setShowCalendar(false);
        }}
      />

      {/* =======================
          PERSONAL MESSAGE
      ========================== */}
      <h3 className="content_change_popup  fs-12 fw-500 global-color mb-5 d-block">
        {t('personal_message_to_recipients_optional')}:
      </h3>

      <textarea
        value={personalMessage}
        onChange={(e) => setPersonalMessage(e.target.value)}
        placeholder={t('write_a_message')}
        className="textarea-style-1"
      />

      {/* =======================
           LANGUAGE SELECTOR
      ========================== */}
      {/* <h3 className="content_change_popup  fs-12 fw-500 global-color mb-5 d-block">
                {t("select_language_for_emails")}:
            </h3>
            <select
                value={emailLanguage}
                onChange={(e) => setEmailLanguage(e.target.value)}
                className="b-1 p-5 mb-10 w-100 fs-14 global-color"
                style={{ outline: "none", cursor: "pointer" }}
            >
                <option value="">{t("select_language")}</option>
                {supportedLanguages.map((langId) => (
                    <option key={langId} value={langId}>
                        {langMap[langId] || `Language ${langId}`}
                    </option>
                ))}
            </select> */}

      {/* =======================
           FOOTER BUTTONS
      ========================== */}
      <div style={styles.footer}>
        <button className="popup-button button_secondary" onClick={onBack}>
          {t('back')}
        </button>

        <button
          className="popup-button button_primary"
          style={{ background: '#007bff' }}
          onClick={() => {
            if (!processOwner || !processOwner.id) {
              CustomAlert.warning(
                t('warning') || 'Warning',
                t('please_assign_process_owner') ||
                  'Please assign a Process Owner or Process Domain Owner before requesting approval.'
              );
              return;
            }
            onStartApproval({
              date: new Date(selectedDate).toISOString(),
              ccRoles,
              personalMessage: personalMessage.replace(/\n/g, '<br />'),
              owner: processOwner,
              emailLanguage: emailLanguage,
              timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
            });
          }}
        >
          {t('start_approval')}
        </button>
      </div>
    </Modal>
  );
};

const styles = {
  heading: { fontSize: '22px', fontWeight: '600' },
  subheading: { fontSize: '12px', marginTop: '15px' },
  label: { fontWeight: '600' },

  userImg: {
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    objectFit: 'cover',
  },

  checkbox: {
    display: 'flex',
    alignItems: 'center',
    gap: '8px',
    marginTop: '8px',
  },

  inlineEditBtn: {
    marginLeft: '10px',
    padding: '3px 8px',
    background: '#007bff',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '12px',
  },

  textarea: {
    width: '100%',
    height: '100px',
    marginTop: '10px',
    padding: '10px',
    borderRadius: '6px',
    border: '1px solid #ccc',
  },

  footer: {
    marginTop: '15px',
    display: 'flex',
    justifyContent: 'space-between',
  },
};

export default ContentChangePopup;
